"use client"

import { Group } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GroupIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GroupIcon = component(Icon)({ as: Group })
